import React from 'react';
import { remCss } from 'src/helpers';
const DoubleArrowIcon = React.memo(({ width = '16', viewBox = '0 0 16 16' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(width)}
    viewBox={viewBox}
  >
    <path id='Path_6268' data-name='Path 6268' d='M0,0H16V16H0Z' fill='none' fillRule='evenodd' />
    <path
      id='Path_6269'
      data-name='Path 6269'
      d='M.2,8.2a.667.667,0,0,0,.943.943l4-4a.667.667,0,0,0,.02-.922l-3.667-4a.667.667,0,1,0-.983.9L3.744,4.647Z'
      transform='translate(8.667 12.667) rotate(180)'
      opacity='0.3'
    />
    <path
      id='Path_6270'
      data-name='Path 6270'
      d='M1.138.2A.667.667,0,0,0,.2,1.138l4,4a.667.667,0,0,0,.922.02l4-3.667a.667.667,0,0,0-.9-.983L4.687,3.744Z'
      transform='translate(13.333 3.333) rotate(90)'
      opacity='0.3'
    />
  </svg>
));
DoubleArrowIcon.displayName = 'DoubleArrowIcon';

export default DoubleArrowIcon;
